<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="73.999"
    height="61"
    viewBox="0 0 73.999 61"
  >
    <g id="Group_4683" data-name="Group 4683" transform="translate(-928 -559)">
      <g
        id="Group_4680"
        data-name="Group 4680"
        transform="translate(21.893 64)"
      >
        <rect
          id="Rectangle_1456"
          data-name="Rectangle 1456"
          width="60"
          height="44"
          rx="5"
          transform="translate(908.108 510)"
          fill="none"
          stroke="#2d323c"
          stroke-width="4"
        />
        <path
          id="Path_2101"
          data-name="Path 2101"
          d="M1.207,2.963,24.3,21.034a7.954,7.954,0,0,0,9.8-.025l23.112-18.3"
          transform="translate(908.901 511.293)"
          fill="none"
          stroke="#2d323c"
          stroke-linecap="square"
          stroke-width="4"
        />
        <g
          id="Lock_icon"
          data-name="Lock icon"
          transform="translate(960.107 499.889)"
        >
          <g
            id="Union_13"
            data-name="Union 13"
            transform="translate(0 -1)"
            fill="#b40068"
          >
            <path
              d="M 12.99960041046143 24.11030006408691 L 3.000600099563599 24.11030006408691 C 0.2432601302862167 24.11030006408691 -1.99999988079071 21.86744117736816 -1.99999988079071 19.11059951782227 L -1.99999988079071 11.11050033569336 C -1.99999988079071 9.511487007141113 -1.2344069480896 8.038580894470215 0.000700135831721127 7.110414505004883 L 0.000700135831721127 5.735700130462646 C 0.000700135831721127 1.531260371208191 3.589620113372803 -1.889299631118774 8.00100040435791 -1.889299631118774 C 12.41188049316406 -1.889299631118774 16.00040054321289 1.531260371208191 16.00040054321289 5.735700130462646 L 16.00040054321289 7.111114501953125 C 17.23497581481934 8.039336204528809 18.00020027160645 9.511979103088379 18.00020027160645 11.11050033569336 L 18.00020027160645 19.11059951782227 C 18.00020027160645 21.86744117736816 15.75693988800049 24.11030006408691 12.99960041046143 24.11030006408691 Z M 6.401000022888184 6.110800266265869 L 9.60099983215332 6.110800266265869 L 9.60099983215332 5.735700130462646 C 9.60099983215332 4.97752046585083 8.88323974609375 4.360700130462646 8.00100040435791 4.360700130462646 C 7.118760108947754 4.360700130462646 6.401000022888184 4.97752046585083 6.401000022888184 5.735700130462646 L 6.401000022888184 6.110800266265869 Z"
              stroke="none"
            />
            <path
              d="M 12.99960041046143 22.11030006408691 C 14.6564998626709 22.11030006408691 16.00020027160645 20.76749992370605 16.00020027160645 19.11059951782227 L 16.00020027160645 11.11050033569336 C 16.00020027160645 9.804520606994629 15.16538047790527 8.693690299987793 14.00040054321289 8.281740188598633 L 14.00040054321289 5.735700130462646 C 14.00040054321289 2.628900289535522 11.31389999389648 0.1107003390789032 8.00100040435791 0.1107003390789032 C 4.68720006942749 0.1107003390789032 2.000700235366821 2.628900289535522 2.000700235366821 5.735700130462646 L 2.000700235366821 8.281410217285156 C 0.8353001475334167 8.693130493164062 1.358032193365943e-07 9.804220199584961 1.358032193365943e-07 11.11050033569336 L 1.358032193365943e-07 19.11059951782227 C 1.358032193365943e-07 20.76749992370605 1.343700170516968 22.11030006408691 3.000600099563599 22.11030006408691 L 12.99960041046143 22.11030006408691 M 8.00100040435791 2.360700368881226 C 9.985500335693359 2.360700368881226 11.60099983215332 3.874500274658203 11.60099983215332 5.735700130462646 L 11.60099983215332 8.110800743103027 L 4.401000022888184 8.110800743103027 L 4.401000022888184 5.735700130462646 C 4.401000022888184 3.874500274658203 6.015600204467773 2.360700368881226 8.00100040435791 2.360700368881226 M 12.99960041046143 26.11030006408691 L 3.000600099563599 26.11030006408691 C -0.8595398664474487 26.11030006408691 -3.999999761581421 22.97025108337402 -3.999999761581421 19.11059951782227 L -3.999999761581421 11.11050033569336 C -3.999999761581421 9.241250038146973 -3.252667188644409 7.495110988616943 -1.999299883842468 6.213283538818359 L -1.999299883842468 5.735700130462646 C -1.999299883842468 4.405230522155762 -1.721569895744324 3.115070343017578 -1.173819899559021 1.901060342788696 C -0.6538298726081848 0.7485503554344177 0.08513013273477554 -0.2813696563243866 1.022530078887939 -1.160109639167786 C 2.899960041046143 -2.920059680938721 5.378290176391602 -3.889299631118774 8.00100040435791 -3.889299631118774 C 10.62339019775391 -3.889299631118774 13.10150051116943 -2.920009613037109 14.97883033752441 -1.159969687461853 C 15.91613006591797 -0.2812396585941315 16.65501022338867 0.7486603260040283 17.17495918273926 1.90112030506134 C 17.72268104553223 3.115130424499512 18.00040054321289 4.405270099639893 18.00040054321289 5.735700130462646 L 18.00040054321289 6.214277744293213 C 19.25323295593262 7.49606466293335 20.00020027160645 9.241824150085449 20.00020027160645 11.11050033569336 L 20.00020027160645 19.11059951782227 C 20.00020027160645 22.97025108337402 16.85973930358887 26.11030006408691 12.99960041046143 26.11030006408691 Z"
              stroke="none"
              fill="#fff"
            />
          </g>
          <circle
            id="Ellipse_282"
            data-name="Ellipse 282"
            cx="2"
            cy="2"
            r="2"
            transform="translate(6 12.111)"
            fill="#fff"
          />
          <rect
            id="Rectangle_1592"
            data-name="Rectangle 1592"
            width="12"
            height="21"
            transform="translate(4)"
            fill="none"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LockedMessages',
}
</script>

<style lang="scss" scoped></style>
